import { api } from "@/api/client";

/* Phase 30 · Slice A — Native Relocation & Experience Orchestrator. */
export const relocationApi = {
  listings: () => api.get("/relocation/listings").then((r) => r.data),
  favorite: (listing_id) => api.post("/relocation/favorite", { listing_id }).then((r) => r.data),
  relocate: (listing_id, origin_city) =>
    api.post("/relocation/relocate", { listing_id, origin_city }).then((r) => r.data),
  foodSearch: (query, basket = []) =>
    api.post("/relocation/food-search", { query, basket }).then((r) => r.data),
  saveManifest: (payload) => api.post("/relocation/manifest/save", payload).then((r) => r.data),
  renderPack: (payload) => api.post("/relocation/render-pack", payload).then((r) => r.data),
};
